<div style="padding:10px;" fxLayout="column">

  <div style="text-align: right;">
    <img alt="close" style="cursor: pointer; justify-content: right;" (click)="onClose()" height="22" width="22"
      src="assets/icons/dialogclose.svg" />
  </div>
  <mat-dialog-content>
    <div fxLayout="row" fxFlex fxLayoutGap="10px">
      <!-- <img alt="icons" height="36" width="36" src="assets/icons/icon-72x72.png" /> -->
      <span fxFlexAlign="center" id="p_title">One Site Pass</span>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions style="margin-top: 5px;">
    <div fxLayout="column" fxFlex>
      <button fxLayoutAlign="center" id="a_btn" (click)="installClicked()">Add to Home screen</button>
    </div>
  </mat-dialog-actions>
</div>